module.exports = __webpack_public_path__ + "img/play.c3be80a6.svg";